export const tr = {
    'accept-button': 'Gösterimlere izin ver',
    'many-pages-title': '{count} kaliteli reklam alanında gösterimlere izin verin',
    'one-page-title': '{count} kaliteli reklam alanında gösterimlere izin verin',
    'simple-progress-hint': 'Kaliteli reklam alanlarında gösterimlere izin veriliyor',
    'some-pages-title': '{count} kaliteli reklam alanında gösterimlere izin verin',
    'title-hint':
        'Tıklama getiren bazı kaliteli siteler engellenen site listenize dahil edildiği için bu öneriyi görüyorsunuz'
};
